
// Auto-generated by openimis-config-vite.js
// Updated for Vite with local file dependencies
import { CoreModule } from "@openimis/fe-core";

export const packages = [
  "@openimis/fe-core",
  "@openimis/fe-individual",
  "@openimis/fe-social_protection",
  "@openimis/fe-opensearch_reports",
  "@openimis/fe-home",
  "@openimis/fe-location",
  "@openimis/fe-insuree",
  "@openimis/fe-medical",
  "@openimis/fe-medical_pricelist",
  "@openimis/fe-product",
  "@openimis/fe-policy",
  "@openimis/fe-payer",
  "@openimis/fe-contribution",
  "@openimis/fe-payment",
  "@openimis/fe-claim",
  "@openimis/fe-claim_batch",
  "@openimis/fe-tools",
  "@openimis/fe-profile",
  "@openimis/fe-calculation",
  "@openimis/fe-policyholder",
  "@openimis/fe-contribution_plan",
  "@openimis/fe-payment_cycle",
  "@openimis/fe-contract",
  "@openimis/fe-tasks_management",
  "@openimis/fe-invoice",
  "@openimis/fe-grievance_social_protection",
  "@openimis/fe-language_fr",
  "@openimis/fe-claim_sampling",
  "@openimis/fe-deduplication",
  "@openimis/fe-payroll",
  "@openimis/fe-notice"
];

export async function loadModules(cfg = {}) {
  const loadedModules = [];
  
  // 🔄 Statically imported CoreModule
  try {
    loadedModules.push(
      CoreModule(cfg["fe-core"] || {})
    );
  } catch (error) {
    console.error(`❌ Failed to initialize module "CoreModule". Error: ${error}`);
    alert(`Failed to load module "CoreModule". See console for details.`);
  }

  // 🔄 Dynamically importing IndividualModule
  try {
    const module = await import("@openimis/fe-individual");
    loadedModules.push(
      module.IndividualModule(cfg["fe-individual"] || {})
    );
  } catch (error) {
    console.error(`❌ Failed to import module "IndividualModule". Error: ${error}`);
    alert(`Failed to load module "IndividualModule". See console for details.`);
  }

  // 🔄 Dynamically importing SocialProtectionModule
  try {
    const module = await import("@openimis/fe-social_protection");
    loadedModules.push(
      module.SocialProtectionModule(cfg["fe-social_protection"] || {})
    );
  } catch (error) {
    console.error(`❌ Failed to import module "SocialProtectionModule". Error: ${error}`);
    alert(`Failed to load module "SocialProtectionModule". See console for details.`);
  }

  // 🔄 Dynamically importing OpenSearchReportsModule
  try {
    const module = await import("@openimis/fe-opensearch_reports");
    loadedModules.push(
      module.OpenSearchReportsModule(cfg["fe-opensearch_reports"] || {})
    );
  } catch (error) {
    console.error(`❌ Failed to import module "OpenSearchReportsModule". Error: ${error}`);
    alert(`Failed to load module "OpenSearchReportsModule". See console for details.`);
  }

  // 🔄 Dynamically importing HomeModule
  try {
    const module = await import("@openimis/fe-home");
    loadedModules.push(
      module.HomeModule(cfg["fe-home"] || {})
    );
  } catch (error) {
    console.error(`❌ Failed to import module "HomeModule". Error: ${error}`);
    alert(`Failed to load module "HomeModule". See console for details.`);
  }

  // 🔄 Dynamically importing LocationModule
  try {
    const module = await import("@openimis/fe-location");
    loadedModules.push(
      module.LocationModule(cfg["fe-location"] || {})
    );
  } catch (error) {
    console.error(`❌ Failed to import module "LocationModule". Error: ${error}`);
    alert(`Failed to load module "LocationModule". See console for details.`);
  }

  // 🔄 Dynamically importing InsureeModule
  try {
    const module = await import("@openimis/fe-insuree");
    loadedModules.push(
      module.InsureeModule(cfg["fe-insuree"] || {})
    );
  } catch (error) {
    console.error(`❌ Failed to import module "InsureeModule". Error: ${error}`);
    alert(`Failed to load module "InsureeModule". See console for details.`);
  }

  // 🔄 Dynamically importing MedicalModule
  try {
    const module = await import("@openimis/fe-medical");
    loadedModules.push(
      module.MedicalModule(cfg["fe-medical"] || {})
    );
  } catch (error) {
    console.error(`❌ Failed to import module "MedicalModule". Error: ${error}`);
    alert(`Failed to load module "MedicalModule". See console for details.`);
  }

  // 🔄 Dynamically importing MedicalPriceListModule
  try {
    const module = await import("@openimis/fe-medical_pricelist");
    loadedModules.push(
      module.MedicalPriceListModule(cfg["fe-medical_pricelist"] || {})
    );
  } catch (error) {
    console.error(`❌ Failed to import module "MedicalPriceListModule". Error: ${error}`);
    alert(`Failed to load module "MedicalPriceListModule". See console for details.`);
  }

  // 🔄 Dynamically importing ProductModule
  try {
    const module = await import("@openimis/fe-product");
    loadedModules.push(
      module.ProductModule(cfg["fe-product"] || {})
    );
  } catch (error) {
    console.error(`❌ Failed to import module "ProductModule". Error: ${error}`);
    alert(`Failed to load module "ProductModule". See console for details.`);
  }

  // 🔄 Dynamically importing PolicyModule
  try {
    const module = await import("@openimis/fe-policy");
    loadedModules.push(
      module.PolicyModule(cfg["fe-policy"] || {})
    );
  } catch (error) {
    console.error(`❌ Failed to import module "PolicyModule". Error: ${error}`);
    alert(`Failed to load module "PolicyModule". See console for details.`);
  }

  // 🔄 Dynamically importing PayerModule
  try {
    const module = await import("@openimis/fe-payer");
    loadedModules.push(
      module.PayerModule(cfg["fe-payer"] || {})
    );
  } catch (error) {
    console.error(`❌ Failed to import module "PayerModule". Error: ${error}`);
    alert(`Failed to load module "PayerModule". See console for details.`);
  }

  // 🔄 Dynamically importing ContributionModule
  try {
    const module = await import("@openimis/fe-contribution");
    loadedModules.push(
      module.ContributionModule(cfg["fe-contribution"] || {})
    );
  } catch (error) {
    console.error(`❌ Failed to import module "ContributionModule". Error: ${error}`);
    alert(`Failed to load module "ContributionModule". See console for details.`);
  }

  // 🔄 Dynamically importing PaymentModule
  try {
    const module = await import("@openimis/fe-payment");
    loadedModules.push(
      module.PaymentModule(cfg["fe-payment"] || {})
    );
  } catch (error) {
    console.error(`❌ Failed to import module "PaymentModule". Error: ${error}`);
    alert(`Failed to load module "PaymentModule". See console for details.`);
  }

  // 🔄 Dynamically importing ClaimModule
  try {
    const module = await import("@openimis/fe-claim");
    loadedModules.push(
      module.ClaimModule(cfg["fe-claim"] || {})
    );
  } catch (error) {
    console.error(`❌ Failed to import module "ClaimModule". Error: ${error}`);
    alert(`Failed to load module "ClaimModule". See console for details.`);
  }

  // 🔄 Dynamically importing ClaimBatchModule
  try {
    const module = await import("@openimis/fe-claim_batch");
    loadedModules.push(
      module.ClaimBatchModule(cfg["fe-claim_batch"] || {})
    );
  } catch (error) {
    console.error(`❌ Failed to import module "ClaimBatchModule". Error: ${error}`);
    alert(`Failed to load module "ClaimBatchModule". See console for details.`);
  }

  // 🔄 Dynamically importing ToolsModule
  try {
    const module = await import("@openimis/fe-tools");
    loadedModules.push(
      module.ToolsModule(cfg["fe-tools"] || {})
    );
  } catch (error) {
    console.error(`❌ Failed to import module "ToolsModule". Error: ${error}`);
    alert(`Failed to load module "ToolsModule". See console for details.`);
  }

  // 🔄 Dynamically importing ProfileModule
  try {
    const module = await import("@openimis/fe-profile");
    loadedModules.push(
      module.ProfileModule(cfg["fe-profile"] || {})
    );
  } catch (error) {
    console.error(`❌ Failed to import module "ProfileModule". Error: ${error}`);
    alert(`Failed to load module "ProfileModule". See console for details.`);
  }

  // 🔄 Dynamically importing CalculationModule
  try {
    const module = await import("@openimis/fe-calculation");
    loadedModules.push(
      module.CalculationModule(cfg["fe-calculation"] || {})
    );
  } catch (error) {
    console.error(`❌ Failed to import module "CalculationModule". Error: ${error}`);
    alert(`Failed to load module "CalculationModule". See console for details.`);
  }

  // 🔄 Dynamically importing PolicyHolderModule
  try {
    const module = await import("@openimis/fe-policyholder");
    loadedModules.push(
      module.PolicyHolderModule(cfg["fe-policyholder"] || {})
    );
  } catch (error) {
    console.error(`❌ Failed to import module "PolicyHolderModule". Error: ${error}`);
    alert(`Failed to load module "PolicyHolderModule". See console for details.`);
  }

  // 🔄 Dynamically importing ContributionPlanModule
  try {
    const module = await import("@openimis/fe-contribution_plan");
    loadedModules.push(
      module.ContributionPlanModule(cfg["fe-contribution_plan"] || {})
    );
  } catch (error) {
    console.error(`❌ Failed to import module "ContributionPlanModule". Error: ${error}`);
    alert(`Failed to load module "ContributionPlanModule". See console for details.`);
  }

  // 🔄 Dynamically importing PaymentCycleModule
  try {
    const module = await import("@openimis/fe-payment_cycle");
    loadedModules.push(
      module.PaymentCycleModule(cfg["fe-payment_cycle"] || {})
    );
  } catch (error) {
    console.error(`❌ Failed to import module "PaymentCycleModule". Error: ${error}`);
    alert(`Failed to load module "PaymentCycleModule". See console for details.`);
  }

  // 🔄 Dynamically importing ContractModule
  try {
    const module = await import("@openimis/fe-contract");
    loadedModules.push(
      module.ContractModule(cfg["fe-contract"] || {})
    );
  } catch (error) {
    console.error(`❌ Failed to import module "ContractModule". Error: ${error}`);
    alert(`Failed to load module "ContractModule". See console for details.`);
  }

  // 🔄 Dynamically importing TasksManagementModule
  try {
    const module = await import("@openimis/fe-tasks_management");
    loadedModules.push(
      module.TasksManagementModule(cfg["fe-tasks_management"] || {})
    );
  } catch (error) {
    console.error(`❌ Failed to import module "TasksManagementModule". Error: ${error}`);
    alert(`Failed to load module "TasksManagementModule". See console for details.`);
  }

  // 🔄 Dynamically importing InvoiceModule
  try {
    const module = await import("@openimis/fe-invoice");
    loadedModules.push(
      module.InvoiceModule(cfg["fe-invoice"] || {})
    );
  } catch (error) {
    console.error(`❌ Failed to import module "InvoiceModule". Error: ${error}`);
    alert(`Failed to load module "InvoiceModule". See console for details.`);
  }

  // 🔄 Dynamically importing GrievanceSocialProtectionModule
  try {
    const module = await import("@openimis/fe-grievance_social_protection");
    loadedModules.push(
      module.GrievanceSocialProtectionModule(cfg["fe-grievance_social_protection"] || {})
    );
  } catch (error) {
    console.error(`❌ Failed to import module "GrievanceSocialProtectionModule". Error: ${error}`);
    alert(`Failed to load module "GrievanceSocialProtectionModule". See console for details.`);
  }

  // 🔄 Dynamically importing LanguageFrModule
  try {
    const module = await import("@openimis/fe-language_fr");
    loadedModules.push(
      module.LanguageFrModule(cfg["fe-language_fr"] || {})
    );
  } catch (error) {
    console.error(`❌ Failed to import module "LanguageFrModule". Error: ${error}`);
    alert(`Failed to load module "LanguageFrModule". See console for details.`);
  }

  // 🔄 Dynamically importing ClaimSamplingModule
  try {
    const module = await import("@openimis/fe-claim_sampling");
    loadedModules.push(
      module.ClaimSamplingModule(cfg["fe-claim_sampling"] || {})
    );
  } catch (error) {
    console.error(`❌ Failed to import module "ClaimSamplingModule". Error: ${error}`);
    alert(`Failed to load module "ClaimSamplingModule". See console for details.`);
  }

  // 🔄 Dynamically importing DeduplicationModule
  try {
    const module = await import("@openimis/fe-deduplication");
    loadedModules.push(
      module.DeduplicationModule(cfg["fe-deduplication"] || {})
    );
  } catch (error) {
    console.error(`❌ Failed to import module "DeduplicationModule". Error: ${error}`);
    alert(`Failed to load module "DeduplicationModule". See console for details.`);
  }

  // 🔄 Dynamically importing PayrollModule
  try {
    const module = await import("@openimis/fe-payroll");
    loadedModules.push(
      module.PayrollModule(cfg["fe-payroll"] || {})
    );
  } catch (error) {
    console.error(`❌ Failed to import module "PayrollModule". Error: ${error}`);
    alert(`Failed to load module "PayrollModule". See console for details.`);
  }

  // 🔄 Dynamically importing NoticeModule
  try {
    const module = await import("@openimis/fe-notice");
    loadedModules.push(
      module.NoticeModule(cfg["fe-notice"] || {})
    );
  } catch (error) {
    console.error(`❌ Failed to import module "NoticeModule". Error: ${error}`);
    alert(`Failed to load module "NoticeModule". See console for details.`);
  }

  return loadedModules;
}
